import { DownloadSimple, VideoCamera } from "@phosphor-icons/react";
import { Flex, Text } from "@radix-ui/themes";
import { useRef } from "react";

import { useHlsPlayer } from "../../../hooks/useHlsPlayer";

interface VideoPreviewBlockProps {
  url: string;
  fileName: string;
}

export function VideoPreviewBlock({ url, fileName }: VideoPreviewBlockProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { error } = useHlsPlayer(videoRef, url);

  if (error) {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-puntt-neutral-gray-6 bg-puntt-neutral-gray-2 p-4">
        <VideoCamera size={20} className="text-puntt-neutral-gray-9" />
        <div className="flex-1">
          <Text size="2" weight="medium" className="text-puntt-neutral-gray-12">
            {fileName}
          </Text>
          <Text as="p" size="1" className="text-puntt-neutral-gray-9">
            Preview unavailable
          </Text>
        </div>
        <a
          href={url}
          download={fileName}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white inline-flex items-center gap-1 rounded-md bg-puntt-accent-9 px-3 py-1.5 text-xs font-medium transition-colors hover:bg-puntt-accent-10"
        >
          <DownloadSimple size={14} />
          Download
        </a>
      </div>
    );
  }

  return (
    <div>
      <Flex align="center" gap="2" className="mb-2">
        <VideoCamera size={16} className="text-puntt-neutral-gray-9" />
        <Text size="2" weight="medium" className="text-puntt-neutral-gray-12">
          {fileName}
        </Text>
        <a
          href={url}
          download={fileName}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-auto"
          title="Download video"
        >
          <DownloadSimple
            size={14}
            className="text-puntt-neutral-gray-9 hover:text-puntt-neutral-gray-12"
          />
        </a>
      </Flex>
      <div className="overflow-hidden rounded-lg border border-puntt-neutral-gray-6">
        <div className="relative max-h-[400px] bg-puntt-neutral-gray-3">
          {/* eslint-disable jsx-a11y/media-has-caption */}
          <video
            ref={videoRef}
            controls
            playsInline
            className="mx-auto block max-h-[400px] w-full object-contain"
          />
        </div>
      </div>
    </div>
  );
}
